<template>
  <div class="rounded-lg border bg-card p-6">
    <h2 class="text-lg font-semibold">Task Buckets</h2>
    <p class="mt-2 text-sm text-muted-foreground">
      Bucket list and payload editing flow will be implemented after templates.
    </p>
  </div>
</template>
